<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="true"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Form>
          <div class="personal-info card">
            <div class="card-header">
              个人信息
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col span="16">
                  <row class="form-item-group">
                    <i-col span="12">
                      <FormItem label="姓名">
                        <div class="detail">{{ info.userName }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="派驻类别">
                        <div class="detail">
                          <span v-if="info.partyTypeList">
                            {{ formatPartyType(info.partyTypeList) }}
                          </span>
                          <span v-if="!info.partyTypeList">
                            {{ formatPartyType(info.partyType) }}
                          </span>
                        </div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="联系电话">
                        <div class="detail">{{ info.phoneNO }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="政治面貌">
                        <div class="detail">
                          {{
                            info.politicalType
                              | politicalFilter(info.politicalType)
                          }}
                        </div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="性别">
                        <div class="detail">
                          {{ info.sex | genderFilter(info.sex) }}
                        </div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="工作单位">
                        <div class="detail">{{ info.workPlace }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="职务">
                        <div class="detail">{{ info.position }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="职级">
                        <div class="detail">
                          {{ formatRank(info.rank) }}
                        </div>
                      </FormItem>
                    </i-col>
                  </row>
                </i-col>
                <i-col span="8">
                  <div class="avatar">
                    <img
                      v-if="info.headPicUrl"
                      class="headPicUrl"
                      :src="info.headPicUrl"
                    />
                    <span class="summary">个人照片</span>
                  </div>
                </i-col>
              </row>
            </div>
          </div>
          <div class="serve-company card">
            <div class="card-header">
              服务企业
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col
                  span="24"
                  v-for="(company, index) in info.companyList"
                  :key="company.id"
                >
                  <div class="card-title">服务企业{{ index + 1 }}</div>
                  <row class="form-item-group">
                    <i-col span="12">
                      <FormItem label="企业名称">
                        <div class="detail">{{ company.companyName }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="企业类别">
                        <div class="detail">
                          {{ formatCompany(company.companyType) }}
                        </div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="企业所在地">
                        <div class="detail">{{ company.companyPlace }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="联系人">
                        <div class="detail">{{ company.name }}</div>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="联系电话">
                        <div class="detail">{{ company.phoneNO }}</div>
                      </FormItem>
                    </i-col>
                  </row>
                </i-col>
              </row>
            </div>
          </div>
        </Form>
      </div>
    </div>
    <Modal v-model="modalIsOpen" :title="modalTitle" :width="550">
      <div>
        {{ modalTitle }}原因（{{ currentIsCheck === 2 ? "必填" : "选填" }}）
      </div>
      <br />
      <Input
        type="textarea"
        v-model="checkMsg"
        :rows="5"
        placeholder="请填写原因..."
      />
      <div slot="footer">
        <Button style="margin-right:10px" @click="modalIsOpen = false"
          >取消</Button
        >
        <Button type="primary" @click="auditHandler" :loading="isBtbLoading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { postChiefWaiter, getChiefWaiterDetail } = api;
import { getPartyTypeDic, getRankDic, getCompanyTypeDic } from "./dic";
export default {
  name: "waiterMoreDetail",
  components: {
    pageHead
  },
  data() {
    return {
      title: "用户管理",
      checkMsg: "",
      modalTitle: "",
      modalIsOpen: false,
      isBtbLoading: false,
      currentAuditId: "",
      currentIsCheck: 1,
      rankList: [],
      companyTypeList: [],
      partyTypeList: [],
      info: {}
    };
  },
  filters: {
    politicalFilter: function(index) {
      if (index === "") return "";
      const politicals = ["群众", "党员", "预备党员"];
      return politicals[index];
    },
    genderFilter: function(index) {
      if (index === "") return "";
      const gender = ["未知", "男", "女"];
      return gender[index];
    }
  },
  computed: {
    btnList() {
      if (this.info.isCheck === 1 || this.info.isCheck === 2) {
        return [
          {
            name: "取消审核",
            type: "cancel"
          },
          {
            name: "编辑",
            type: "edit"
          }
        ];
      } else if (this.info.isCheck === 0) {
        return [
          {
            name: "审核通过",
            type: "pass"
          },
          {
            name: "审核不通过",
            type: "not"
          },
          {
            name: "编辑",
            type: "edit"
          }
        ];
      } else if (this.info.isCheck === 3) {
        return [
          {
            name: "编辑",
            type: "edit"
          }
        ];
      }
    },
    formatPartyType() {
      return function(type) {
        if (!type) return;
        const levelArr = type.split(",");
        let name = "";
        this.partyTypeList.filter(item => {
          if (item.value === levelArr[0]) {
            name = item.label;
            if (levelArr[1] && item.children) {
              item.children.filter(inner => {
                if (inner.value === levelArr[1]) {
                  name = name + "/" + inner.label;
                }
              });
            }
          }
          return;
        });
        console.log("看看处理后的数据：", name);
        return name;
      };
    },
    formatRank() {
      return function(index) {
        const arr = this.rankList.filter(item => item.dicIndex === index);
        if (arr.length > 0) {
          return arr[0].dicName;
        } else {
          return "";
        }
      };
    },
    formatCompany() {
      return function(index) {
        const arr = this.companyTypeList.filter(
          item => item.dicIndex === index
        );
        if (arr.length > 0) {
          return arr[0].dicName;
        } else {
          return "";
        }
      };
    }
  },
  methods: {
    handleBtn(type) {
      const handler = this[type + "Handler"];
      handler && handler();
    },
    // 编辑
    editHandler() {
      console.log("我是编辑");
      this.$router.push({
        name: "addChiefWaiter",
        query: { id: this.info.id }
      });
    },
    // 取消审核
    cancelHandler() {
      console.log("我是取消审核");
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 0;
      this.$Modal.confirm({
        title: "是否取消审核",
        onOk: () => {
          this.auditHandler();
        }
      });
    },
    // 审核不通过
    notHandler() {
      console.log("我是审核不通过");
      this.modalTitle = "审核不通过";
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 2;
      this.openModal();
    },
    // 审核通过
    passHandler() {
      console.log("我是审核通过");
      this.modalTitle = "审核通过";
      this.currentAuditId = this.info.id;
      this.currentIsCheck = 1;
      this.openModal();
    },
    // 打开模态框
    openModal() {
      if (!this.modalIsOpen) {
        this.modalIsOpen = true;
        this.checkMsg = "";
      }
    },
    async auditHandler() {
      if (this.currentIsCheck === 2) {
        if (!this.checkMsg) {
          return this.$Message.info("请填写审核说明");
        }
      }
      const id = this.currentAuditId || "";
      const isCheck = this.currentIsCheck;
      const remark = this.checkMsg || "";
      console.log("看看这里是什么数据", remark);
      this.isBtbLoading = true;
      try {
        const res = await this.$post(postChiefWaiter, {
          remark,
          id,
          isCheck
        });
        if (res.isSucceed) {
          this.modalIsOpen = false;
          this.checkMsg = "";
          this.$Message.info("操作成功");
          this.initData();
        }
      } finally {
        this.isBtbLoading = false;
        this.checkedId = "";
      }
    },
    // 获取职级
    async getRankList() {
      const res = await this.$get(getRankDic);
      if (res.isSucceed) {
        this.rankList = res.rows || [];
      }
    },
    // 获取企业类型
    async getCompanyTypeList() {
      const res = await this.$get(getCompanyTypeDic);
      if (res.isSucceed) {
        this.companyTypeList = res.rows || [];
      }
    },
    // 数据初始化
    async initData() {
      try {
        const { id } = this.$route.query;
        let res = await this.$get(getChiefWaiterDetail(id));
        if (res.isSucceed && res.rows) {
          this.info = res.rows[0];
        }
      } finally {
      }
    },
    // 获取驻派类别
    async getPartyTypeList() {
      const res = await this.$get(getPartyTypeDic);
      this.partyTypeList = res.rows.length ? this.formateData(res.rows) : [];
      // console.log("查看驻派类别数据：", this.partyTypeList);
    },
    // 格式化驻派类别数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.dicType,
          label: item.dicName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    }
  },
  created() {
    this.initData();
    this.getPartyTypeList();
    this.getRankList();
    this.getCompanyTypeList();
  }
};
</script>

<style scoped lang="less">
.content {
  margin: 20px;
}
.avatar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.card {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 20px;
  .card-header {
    padding: 20px;
    border-bottom: 1px solid #dedede;
  }
  .card-body {
    padding: 20px;
    .card-title {
      color: #ff7c44;
    }
  }
}
.detail {
  color: #666;
}
.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.success {
  color: #ff7b44;
}
/deep/ .ivu-form-item-label {
  color: #9a9a9a;
}
</style>
